export interface SupportMessageMediaItem {
  objectKey?: string | null;
  contentType?: string | null;
  fileName?: string | null;
  fileSize?: number | null;
  error?: string | null;
}

export function parseSupportMessageMedia(contentAttributes?: string | null): SupportMessageMediaItem[] {
  if (!contentAttributes)
  {
    return [];
  }

  try
  {
    const parsed = JSON.parse(contentAttributes) as { media?: SupportMessageMediaItem[] };
    if (!Array.isArray(parsed.media))
    {
      return [];
    }

    return parsed.media;
  }
  catch
  {
    return [];
  }
}
